import M from 'materialize-css';
import React, { useEffect, useRef, useState } from "react";
import { validation } from "../../utils/handleChangeHooks";
import { isNullOrEmpty, isWebMobile, translate } from '../../utils/util';

const SelectNew = (props) => {
    const [refresh, setRefresh] = useState(0);
    const [full, setFull] = useState(false);
    const selectRef = useRef();

    useEffect(() => {
        M.FormSelect.init(selectRef.current);
        // eslint-disable-next-line
    }, [selectRef, props.data, props.defaultValue, refresh]);

    useEffect(() => {
        let element = document.getElementById(props.id);
        element.value = props.defaultValue;

        // eslint-disable-next-line
    }, [props.defaultValue]);

    useEffect(() => {
        if (props.multiple && Array.isArray(props.defaultValue)) {
            props.defaultValue.forEach(valueProps => {
                for (let index = 2; index < selectRef.current.options.length; index += 1) {
                    const element = selectRef.current.options[index];
                    if (!isNullOrEmpty(valueProps) && !isNullOrEmpty(element.value) && element.value === valueProps.toString()) {
                        element.selected = true;
                    }
                }
            });

        }
        // eslint-disable-next-line
    }, [props.defaultValue, props.data]);

    const isMobile = () => {
        return (isWebMobile() || navigator.userAgent === 'logisticspwa') && !props.multiple
    }

    const onDisable = () => {
        for (let index = 2; index < selectRef.current.options.length; index += 1) {
            const element = selectRef.current.options[index];
            element.selected = false;
        }

        if (props.clearAll) {
            props.clearAll();
        }
        setRefresh(refresh + 1);
        setFull(false);
    }

    const onChange = (event) => {
        if (full) {
            return onDisable();
        }

        if (event.currentTarget.value === 'full') {
            for (let index = 2; index < selectRef.current.options.length; index += 1) {
                const element = selectRef.current.options[index];
                if (element.value !== 'full' && props.changeAll) {
                    element.selected = true;
                    props.changeAll(element.value);
                }
            }
            setFull(true);
            setRefresh(refresh + 1)
        } else {
            validation(selectRef.current);
            if (props.change) {
                props.change(event);
            }
        }
    };

    return (
        <div className={`${props.default ? "" : "input-field"}`}>
            {!props.default &&
                <label style={{ position: "relative" }} htmlFor={props.id} className={props.className}>{props.label}</label>}
            <select
                disabled={props.disabled}
                className={(isMobile() ? "browser-default select" : `${props.className} select`)}
                id={props.id}
                // style={{ border: isMobile() && "solid", borderWidth: isMobile() && "0px 0px 1px 0px", borderColor: isMobile() && "#597dda" }}
                rowindex={props.rowindex || 0}
                required={(props.required && props.required !== false)}
                name={props.name}
                ref={selectRef}
                onChange={onChange}
                value={props.value}
                multiple={props.multiple || false}
                validation-field={props['validation-field'] ? props['validation-field'] : props.name}
            >
                {
                    !props.notOption && <option disabled={props.disablePlaceHoderSelect} value="">{props.placeHolder ? props.placeHolder : translate('choose-one-option', 'general')}</option>
                }
                {
                    props.multiple && props.data && props.data.length > 0 && <option id="full" value="full">Selecionar Todos</option>
                }
                {
                    props.data ? props.data.map((item, index) => {
                        return (
                            <option key={`${index}-options`} value={item[props.valuefield] || item.id}>{item[props.display] || item.text}</option>);
                    }) : null
                }
            </select>
            {props.default &&
                <label>{props.label}</label>}
        </div>
    );
};

export default SelectNew;
